// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1yxDE","title":"BackImages_title__2SnXR","images":"BackImages_images__3BFrb"};